<template>
  <div class="modal fade" id="modal" tabindex="-1" aria-labelledby="modalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title hero-small__default-title" data-translate="SORRY_ERROR_HEADLINE2"></h4>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <p class="js-commonErrors ownText"></p>
          <p class="js-commonErrors maxTicketSum" data-translate="SORRY_ERROR_TICKET_SUM_LIMIT_EXCEEDED"></p>
          <p class="js-commonErrors maxTicketQuantity" data-maxquantity="0" data-translate="SORRY_ERROR_TICKET_QUANTITY_LIMIT_EXCEEDED"></p>
          <p class="js-commonErrors noRemainingContingent" data-translate="SORRY_ERROR_TICKETCATEGORY_CONTINGENT_EXCEEDED_DECREASE"></p>
          <p class="js-commonErrors currencyError" data-translate="SORRY_ERROR_TICKETCATEGORY_CURRENCY_ERROR"></p>
          <p class="js-commonErrors shippingtype" data-translate="SORRY_ERROR_TICKET_SHIPPINGTYPES_INCOMPATIBLE"></p>
          <p class="js-cartrules maximumContingentForTicket">
            <span data-translate="SORRY_ERROR_TICKETCATEGORY_MAXIMUM_FOR_CATEGORY"></span>
            <span class="js-cartrule-category-name"></span>
            <span data-translate="SORRY_ERROR_TICKETCATEGORY_MAXIMUM_IS"></span>
            <span class="js-cartrule-category-maximum"></span>
          </p>
          <p class="js-cartrules minimumContingentForTicket">
            <span data-translate="SORRY_ERROR_TICKETCATEGORY_MINIMUM_FOR_CATEGORY"></span>
            <span class="js-cartrule-category-name"></span>
            <span data-translate="SORRY_ERROR_TICKETCATEGORY_MINIMUM_IS"></span>
            <span class="js-cartrule-category-minimum"></span>
          </p>
          <p class="js-cartrules maximumContingentForAll">
            <span data-translate="SORRY_ERROR_TICKETCATEGORY_MAXIMUM_FOR_ALL_IS"></span>
            <span class="js-cartrule-maximum"></span>
          </p>
          <p class="js-cartrules minimumContingentForAll">
            <span data-translate="SORRY_ERROR_TICKETCATEGORY_MINIMUM_FOR_ALL_IS"></span>
            <span class="js-cartrule-minimum"></span>
          </p>
          <p class="js-cartrules combiTicket">
            <span data-translate="SORRY_ERROR_TICKETCATEGORY_COMBI_COUNT_FOR_CATEGORY">Ticket count for category</span>
            <span class="js-cartrule-category-name2"></span>
            <span class="js-cartrule-category-must-be" data-translate="SORRY_ERROR_TICKETCATEGORY_COMBI_MUST_BE">must be</span>
            <span class="js-cartrule-category-factor"></span>
            <span class="js-cartrule-category-times-the-ticket" data-translate="SORRY_ERROR_TICKETCATEGORY_COMBI_TIMES_THE">times the ticket count for category</span>
            <span class="js-cartrule-category-equal" data-translate="SORRY_ERROR_TICKETCATEGORY_COMBI_COUNT_MUST_BE_EQUAL">must be equal to the ticket count for category</span>
            <span class="js-cartrule-category-name1"></span>
          </p>
          <p class="js-cartrules exclusiveTicket">
            <span data-translate="SORRY_ERROR_TICKETCATEGORY_EXCLUSIVE_1"></span>
            <span class="js-cartrule-category-name1"></span>
            <span data-translate="SORRY_ERROR_TICKETCATEGORY_EXCLUSIVE_2"></span>
            <span class="js-cartrule-category-name2"></span>
            <span data-translate="SORRY_ERROR_TICKETCATEGORY_EXCLUSIVE_3"></span>
          </p>
          <p class="js-cartrules atleastTicket">
            <span data-translate="SORRY_ERROR_TICKETCATEGORY_ATLEAST_1"></span>
            <span class="js-cartrule-category-name1"></span>
            <span data-translate="SORRY_ERROR_TICKETCATEGORY_ATLEAST_2"></span>
            <span class="js-cartrule-category-name2"></span>
            <span data-translate="SORRY_ERROR_TICKETCATEGORY_ATLEAST_3"></span>
          </p>
          <p class="js-cartrules minimumvalueTicket">
            <span data-translate="SORRY_ERROR_TICKETCATEGORY_MINIMUMVALUE_1"></span>
            <span class="js-cartrule-category-cartvalue"></span>
            <span data-translate="SORRY_ERROR_TICKETCATEGORY_MINIMUMVALUE_2"></span>
            <span class="js-cartrule-category-name"></span>
            <span data-translate="SORRY_ERROR_TICKETCATEGORY_MINIMUMVALUE_3"></span>
          </p>
        </div>
        <div class="modal-footer">
          <div class="d-grid gap-2 w-100">
            <button type="button" class="btn btn-dark" data-dismiss="modal" data-translate="SORRY_ERROR_MODAL_OK">OK</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ErrorModal"
}
</script>

<style scoped>

</style>